import React, { useEffect, useState } from "react";
import {
  Box, Button, Card, CardContent, CardHeader,
  TextField, MenuItem
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { NotificationServices } from "../../services/AllServices";
import errorHandler from "../../utils/errorHandler";
import { toast } from "react-toastify";

export default function NotificationTemplateForm() {
  const { id } = useParams();
  const isEdit = Boolean(id);
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    slug: "",
    title: "",
    message: "",
    status: 1
  });

  useEffect(() => {
    if (isEdit) fetchData();
  }, [id]);

  const fetchData = async () => {
    try {
      const res = await NotificationServices.getById({ id });
      if (res.status === 200) {
        setForm(res?.data?.data);
      }
    } catch (err) {
      errorHandler(err);
    }
  };

  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "name") {
      setForm({ ...form, name: value });
      return;
    }

    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async () => {
    try {
      let payload = { ...form };

      if (isEdit) {
        // Remove _id and use id instead
        const { _id, ...rest } = payload;
        payload = { ...rest, id: _id || id };
      }

      let res = isEdit
        ? await NotificationServices.update(payload)
        : await NotificationServices.create(payload);

      if (res.status === 200) {
        toast.success(res?.data?.message || "Saved Successfully");
        navigate("/notification-management");
      }

    } catch (err) {
      errorHandler(err);
    }
  };

  return (
    <Box>
      <Card sx={{ mb: 2 }}>
        <CardHeader title={isEdit ? "Edit Template" : "Create Template"} />
      </Card>

      <Card>
        <CardContent>
          <Box display="grid" gridTemplateColumns="repeat(2,1fr)" gap={2}>

            <TextField
              label="Name"
              name="name"
              value={form.name}
              onChange={handleChange}
              fullWidth
            />

            <TextField
              label="Slug"
              name="slug"
              value={form.slug}
              disabled
              fullWidth
            />

            <TextField
              label="Title"
              name="title"
              value={form.title}
              onChange={handleChange}
              fullWidth
            />         

            <TextField
              select
              label="Status"
              name="status"
              value={form.status}
              onChange={handleChange}
              fullWidth
            >
              <MenuItem value={1}>Active</MenuItem>
              <MenuItem value={0}>Inactive</MenuItem>
            </TextField>

            <TextField
              label="Message"
              name="message"
              value={form.message}
              onChange={handleChange}
              multiline
              rows={5}
              fullWidth
            />

          </Box>

          <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
            <Button variant="outlined" onClick={() => navigate("/notification-management")}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSubmit}>
              {isEdit ? "Update" : "Create"}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
